export default "__VITE_ASSET__CMYjJovB__"